import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonModal,
    IonTitle,
    IonToolbar
} from "@ionic/react";
import { Drawer } from "@mui/material";
import { close } from "ionicons/icons";
import { GrClose } from "react-icons/gr";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import EmptyCart from "../../assets/empty-cart.png";
import { useCart } from "../../hooks/useCart";
import { t } from "../../translations";
import { shouldUseIonicComponents } from "../../utils/platformUtils";
import { Aa } from "../functions/Aa";
import "./cart-drawer-ionic.css";
const CartDrawer = ({ open, onClose, onUpdateCart }) => {
  const history = useHistory();
  const cart = useSelector((state) => state.cart);
  const selectedChef = useSelector((state) => state.selectedChef);
  const selectedWhen = useSelector((state) => state.selectedWhen);
  const selectedLang = useSelector((state) => state.lang);
  const useMobileUI = shouldUseIonicComponents();

  // Use cart service for cart statistics
  const { getStats } = useCart();
  const cartStats = getStats();

  // Calculate current date (formatted for display)
  const getCurrentDate = () => {
    if (selectedWhen) {
      const date = new Date(selectedWhen);
      return date.toLocaleDateString(
        selectedLang === "fr" ? "fr-FR" : "en-US",
        {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric"
        }
      );
    }
    return "";
  };

  const handleQuantityChange = (item, newQty) => {
    if (onUpdateCart) {
      const updatedCart = cart.map((data) => {
        if (data?._id === item?._id) {
          return { ...data, qty: newQty };
        }
        return { ...data };
      });
      onUpdateCart(updatedCart);
    }
  };

  const handleIncrement = (item) => {
    const currentQty = cart?.find((data) => data?._id === item?._id)?.qty || 0;
    if (currentQty >= 10) {
      return;
    }
    handleQuantityChange(item, currentQty + 1);
  };

  const handleDecrement = (item) => {
    const currentQty = cart?.find((data) => data?._id === item?._id)?.qty || 0;
    if (currentQty <= 1) {
      return;
    }
    handleQuantityChange(item, currentQty - 1);
  };

  const handleViewCart = () => {
    onClose();
    history.push(
      `/order/chef/menu/cart?chef=${selectedChef?._id}&date=${selectedWhen}`
    );
  };

  // Render mobile version with IonModal (bottom sheet)
  if (useMobileUI) {
    return (
      <IonModal
        isOpen={open}
        onDidDismiss={onClose}
        breakpoints={[0, 0.25, 0.5, 0.75, 0.85, 1]}
        initialBreakpoint={0.85}
        className="ionic-cart-modal"
        style={{ "--width": "85%", "--height": "85%" }}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>
              {cartStats.isEmpty
                ? t("navbar.cart", selectedLang)
                : t("navbar.cart_order_from", selectedLang) +
                  (Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname))}
            </IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={onClose}>
                <IonIcon icon={close} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ionic-cart-content">
          {cartStats.isEmpty && (
            <div className="ionic-empty-cart">
              <img
                alt="empty-cart"
                src={EmptyCart}
                className="ionic-empty-cart-image"
              />
              <p className="ionic-empty-cart-message">
                {t("navbar.empty_cart_message", selectedLang)}
              </p>
            </div>
          )}

          {!cartStats.isEmpty && (
            <>
              <div className="ionic-cart-delivery-info">
                {t("navbar.cart_order_delivery", selectedLang)}
                {getCurrentDate()}
              </div>

              <IonList className="ionic-cart-list">
                {cart?.map((item) => (
                  <IonItem key={item?._id} className="ionic-cart-item">
                    <div className="ionic-cart-item-content">
                      <div className="ionic-cart-item-controls">
                        <button
                          className="ionic-cart-qty-btn"
                          onClick={() => handleDecrement(item)}
                        >
                          -
                        </button>
                        <span className="ionic-cart-qty">{item?.qty}</span>
                        <button
                          className="ionic-cart-qty-btn"
                          onClick={() => handleIncrement(item)}
                        >
                          +
                        </button>
                      </div>
                      <div className="ionic-cart-item-details">
                        <IonLabel className="ionic-cart-item-name">
                          {item?.name?.slice(0, 25) + "..."}
                        </IonLabel>
                        <span className="ionic-cart-item-price">
                          {"$" + (item?.cost * item?.qty)?.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  </IonItem>
                ))}
              </IonList>

              <div className="ionic-cart-footer">
                <IonButton
                  expand="block"
                  color="primary"
                  className="ionic-view-cart-btn"
                  onClick={handleViewCart}
                >
                  <div className="ionic-view-cart-content">
                    <span>{t("navbar.see_cart", selectedLang)}</span>
                    <span className="ionic-cart-total">
                      {"$" +
                        cart?.reduce((a, b) => a + b?.cost * b?.qty, 0)?.toFixed(2)}
                    </span>
                  </div>
                </IonButton>
              </div>
            </>
          )}
        </IonContent>
      </IonModal>
    );
  }

  // Render web version (existing design)
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <div
        style={{
          width: 300
        }}
      >
        <span
          style={{
            margin: 10
          }}
        >
          <GrClose size={30} onClick={onClose} style={{ cursor: "pointer" }} />
        </span>
        <hr />
        <h2
          style={{
            padding: 7,
            marginLeft: 10
          }}
        >
          {cartStats.isEmpty
            ? ""
            : t("navbar.cart_order_from", selectedLang) +
              (Aa(selectedChef?.firstname) + " " + Aa(selectedChef?.lastname))}
        </h2>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {cartStats.isEmpty && (
            <>
              <img
                alt="empty-cart"
                src={EmptyCart}
                style={{
                  marginTop: 30,
                  width: 200
                }}
                s
              />
              <p
                style={{
                  marginTop: 20,
                  fontSize: 16,
                  color: "#666",
                  textAlign: "center",
                  padding: "0 20px",
                  lineHeight: "1.4"
                }}
              >
                {t("navbar.empty_cart_message", selectedLang)}
              </p>
            </>
          )}
        </div>
        {!cartStats.isEmpty && (
          <>
            <span
              style={{
                marginLeft: 13,
                fontWeight: 500
              }}
            >
              {t("navbar.cart_order_delivery", selectedLang)}
              {getCurrentDate()}
            </span>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap"
              }}
            >
              {cart?.map((item) => (
                <div
                  className="section-food-list-right-cart-btn"
                  key={item?._id}
                >
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => handleDecrement(item)}
                  >
                    -
                  </span>
                  <span>{item?.qty}</span>
                  <span
                    className="section-food-list-right-cart-btn-span"
                    onClick={() => handleIncrement(item)}
                  >
                    +
                  </span>
                  <span
                    style={{
                      fontSize: 15
                    }}
                  >
                    {item?.name?.slice(0, 25) + "..."}
                  </span>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 15
                    }}
                  >
                    {"$" + (item?.cost * item?.qty)?.toFixed(2)}
                  </span>
                </div>
              ))}
              <div
                className="btn-see-cart"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  width: "95%",
                  height: 50,
                  borderRadius: 25,
                  backgroundColor: "#FF114D",
                  marginTop: 20,
                  cursor: "pointer"
                }}
                onClick={handleViewCart}
              >
                <span
                  style={{
                    color: "#fff",
                    fontSize: 15
                  }}
                >
                  {t("navbar.see_cart", selectedLang)}
                </span>
                <span
                  style={{
                    backgroundColor: "#fff",
                    height: 40,
                    width: 80,
                    borderRadius: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: 15,
                    fontWeight: 700
                  }}
                >
                  {"$" +
                    cart?.reduce((a, b) => a + b?.cost * b?.qty, 0)?.toFixed(2)}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
    </Drawer>
  );
};

export default CartDrawer;
